/** Strings owned by `src/features/departments/` — WP-12's Departments
 * section in the normal app (§ Bedrijfscontext, § Zichtbaarheid). */
export const departments = {
  page: {
    title: 'Afdelingen',
    leadPersonal: 'Afdelingen waar je lid van bent.',
    leadCompany: 'Afdelingen binnen {{company}}.',
  },
  list: {
    cardTitle: 'Afdelingen',
    name: 'Naam',
    company: 'Bedrijf',
    statistics: 'Statistieken',
    collectiveConsent: 'Collectieve toestemming',
    inForce: 'van kracht',
    none: '—',
    unattached: 'niet gekoppeld',
    empty: 'Nog geen afdelingen hier.',
    newDepartment: 'Nieuwe afdeling',
  },
  compare: {
    cardTitle: 'Vergelijking tussen afdelingen',
    pageTitle: 'Vergelijking tussen afdelingen',
    lead: 'Vergelijking van de afdelingen waarvan je de statistieken mag zien.',
    empty: 'Geen enkele afdeling hier heeft statistieken die je mag zien.',
  },
  detail: {
    thisDepartment: 'afdeling',
    edit: 'Bewerken',
    setVisibility: 'Zichtbaarheid instellen',
    collectiveConsent: 'Collectieve toestemming',
    coach: 'Coach',
    category: 'Categorie',
    type: 'Type',
    statistics: 'Statistieken',
    notRecorded: 'niet vastgelegd',
    membersCardTitle: 'Leden',
    statsCardTitle: 'Statistieken',
    settingsCardTitle: 'Instellingen',
    addPerson: 'Persoon toevoegen',
    name: 'Naam',
    nickname: 'Bijnaam',
    login: 'Login',
    yes: 'ja',
    no: 'nee',
    noMembers: 'Geen leden.',
  },
  form: {
    newTitle: 'Nieuwe afdeling',
    newLead:
      'Elke nieuwe afdeling begint aggregate-only — de privacyvriendelijke stand die je krijgt door niets te doen.',
    name: 'Naam',
    category: 'Categorie',
    type: 'Type',
    cancel: 'Annuleren',
    create: 'Afdeling aanmaken',
    editTitle: 'Afdeling bewerken',
    save: 'Opslaan',
    deleteCardTitle: 'Verwijderen',
    deleteButton: 'Deze afdeling verwijderen',
    deleteConfirm: '{{name}} definitief verwijderen?',
    deleteKeep: 'Behouden',
    deleteYes: 'Ja, verwijderen',
    visibilityTitle: 'Zichtbaarheid van statistieken',
    visibilityLead:
      'individual stelt op zich niemand bloot: het staat individuele toegang toe waar een toestemmingsbasis het lid dekt. Overschakelen naar individual zonder collectief record maakt voor elk huidig lid een openstaande toestemmingsvraag aan.',
    visibilityAggregate: 'aggregate — enkel groepscijfers',
    visibilityIndividual: 'individual — toegang per lid waar toestemming dat dekt',
    collectiveConsentTitle: 'Collectieve toestemmingsbasis',
    collectiveConsentLead:
      'Zolang een collectief record van kracht is, geldt het voor elk lid van {{name}}, ongeacht diens persoonlijke antwoord. De eigen rijen van leden blijven bewaard en gelden weer zodra het wordt ingetrokken.',
    collectiveConsentNote: 'Overeenkomst buiten het platform (identificeer precies)',
    collectiveConsentRecord: 'Collectieve basis vastleggen',
    revokeCardTitle: 'Intrekken',
    revokeButton: 'Collectieve basis intrekken',
  },
} as const;
